import { render } from "./dealer_add.vue?vue&type=template&id=227d7d79"
import script from "./dealer_add.vue?vue&type=script&lang=js"
export * from "./dealer_add.vue?vue&type=script&lang=js"

import "./dealer_add.vue?vue&type=style&index=0&id=227d7d79&lang=css"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__